import React from 'react';
import { motion } from 'motion/react';
import { UtensilsCrossed, Car } from 'lucide-react';
import { useSettings } from '../context/SettingsContext';

export function ServicesInfo() {
  const { settings } = useSettings();

  return (
    <section className="py-8 bg-white border-t border-b border-black/5">
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
        <motion.div 
          initial={{ opacity: 0, y: 10 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="flex flex-col md:flex-row justify-center items-center gap-6 md:gap-16 text-center"
        >
          {/* Catering */}
          <div className="flex items-center gap-3 text-gusto-gray text-sm md:text-base">
            <div className="bg-gusto-gold/10 p-2.5 rounded-full shrink-0">
              <UtensilsCrossed className="w-5 h-5 md:w-6 md:h-6 text-gusto-gold" />
            </div>
            <span 
              className="text-left max-w-[280px] sm:max-w-none [&>strong]:font-bold" 
              dangerouslySetInnerHTML={{ __html: settings.catering_text }}
            />
          </div>

          <div className="hidden md:block w-px h-12 bg-black/10"></div>

          {/* Car Wash */}
          <div className="flex items-center gap-3 text-gusto-gray text-sm md:text-base">
            <div className="bg-gusto-red/10 p-2.5 rounded-full shrink-0">
              <Car className="w-5 h-5 md:w-6 md:h-6 text-gusto-red" />
            </div>
            <span 
              className="text-left max-w-[280px] sm:max-w-none [&>strong]:font-bold"
              dangerouslySetInnerHTML={{ __html: settings.carwash_text }}
            />
          </div>
        </motion.div>
      </div>
    </section>
  );
}
